import { CSSResult, unsafeCSS } from 'lit';

export function designTokenFactory(rootName: string): (tokenPath: string, state?: string) => CSSResult {
  return (tokenPath: string, state?: string) => {
    const tokenParts = tokenPath.split('.');

    if (state) {
      tokenParts.unshift(...state.split('.'));
    }

    return unsafeCSS(`--y-${rootName}-${tokenParts.join('-')}`);
  };
}
